import { useSelector } from "react-redux";
import { useEffect } from "react";

import StatisticItem from "../StatisticListingItem/StatisticListingItem";
import { RootState } from "@/store/store";
import useGetStatistic from "@/hooks/useGetStatistic";

import "./StatsDebtorsListing.scss";

export default function StatsDebtorsListing() {
    const { handleGetStats } = useGetStatistic();
    const debtorArray = useSelector(
        (state: RootState) => state.statictic.debtorsArray,
    );
    useEffect(() => {
        handleGetStats({
            entity: "debtors",
            message: "Звіт про боржників сформовано",
        });
    }, []);

    return (
        <>
            {debtorArray.length > 0 ? (
                <ul className='stats_listing_ul'>
                    {debtorArray.map((item, index) => (
                        <StatisticItem item={item} key={index} />
                    ))}
                </ul>
            ) : (
                <p className='stats_listing_p'>Боржники відсутні</p>
            )}
        </>
    );
}
